export default "__VITE_ASSET__CG1EuCHP__"